// @core/api/endpoints/affiliate/get_conversion.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ConversionResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Get conversion by ID
 * Retrieves conversion by the specified identifier.
 */
export async function GetConversion(
  conversion_id: string,
  options?: RequestOptions
): Promise<ConversionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversions/:conversion_id`;
  requestPath = requestPath.replace(':conversion_id', encodeURIComponent(conversion_id));
  const requestOptions = options;
  return client.get<ConversionResponse>(requestPath, { ...requestOptions });
}
